<template>
  <div class="form-group">
    <template v-if="value"
      ><img class="px-2 py-2 mb-3 img-thumbnail img-fluid" :src="value" v-if="type === 'image'" />
      <p v-else>{{ fileName }}</p>
    </template>
    <input type="file" ref="fileReader" hidden="true" @change="onDrop($event)" />
    <div
      class="image-upload-collapsed"
      v-bind:class="{ active: fileHover }"
      v-on:click=""
      v-on:dragstart="$event.preventDefault()"
      v-on:dragover="onDragOver($event)"
      v-on:dragleave="dragLeave"
      v-on:drop="onDrop($event)"
    >
      <p>
        <button class="btn btn-primary" @click="$refs.fileReader.click()">{{ $t('choose_file') }}</button
        ><span class="ml-2">{{ 'Vælg eller træk og slip en fil du vil tilføje' }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    fileSelected: function () {
      return this.slipTemplate && this.slipTemplate.logo;
    }
  },
  data: function () {
    return {
      file: this.value || '',
      fileName: '',
      fileHover: false
    };
  },
  methods: {
    onDragOver: function (e) {
      e.preventDefault();
      this.fileHover = true;
    },
    onDrop: function (e) {
      e.preventDefault();
      this.fileHover = false;
      let files = e.target.files || e.dataTransfer.files;

      if (files.length == 0) return;

      var read = new FileReader();

      this.fileName = files[0].name;

      read.onload = (e) => {
        //thisRef.image = e.target.result
        this.$emit('input', e.target.result);
      };

      read.readAsDataURL(files[0]);
    },
    dragLeave: function (e) {
      e.preventDefault();
      this.fileHover = false;
    }
  },
  props: ['value', 'type']
};
</script>

<style scoped></style>
